module.exports = __webpack_public_path__ + "lazerSlideLeft.webp?019815bee1bb6d716c7ef26ebe965df4";